import React from 'react';
import { Link } from 'react-router-dom';
import AiToolWrapper from '../components/AiToolWrapper';

// ★ IMPORT THE NEW CONTROL CARTRIDGE ★
import BgReplaceControls from '../components/ToolEngine/Controls/BgReplaceControls';

import './BgReplacePage.css';

export default function BgReplacePage({ session }) {
  
  // SEO Schema
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "FullMockup AI Background Replacer",
    "applicationCategory": "DesignApplication",
    "operatingSystem": "Web Browser",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    "description": "Generative AI tool to replace image backgrounds seamlessly."
  };

  return (
    <div className="replace-bg-page fade-in">
      {/* Inject SEO */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* --- A. HEADER --- */}
      <header className="tool-page-header">
        <h1>Replace Backgrounds Instantly</h1>
        <p>Instantly place your product into any setting. Choose a solid color or upload a custom scene.</p>
      </header>

      {/* --- B. WORKSPACE (Using the New Engine) --- */}
      <div className="tool-workspace-container">
        <AiToolWrapper 
          title="Replace Background"
          apiEndpoint="/api/tools/replace-background"
          
         
          // We pass the new Brown Controls instead of the old settings file
          SettingsFormComponent={BgReplaceControls}
          
          session={session}
          actionName="Replace Background"
          layoutVariant="slider" 
        />
      </div>

      {/* --- C. SEO & FAQ SECTION --- */}
      <section className="tool-seo-section">
        <div className="seo-content-block">
          <h2>What is FullMockup's Background Replacer?</h2>
          <p>
            FullMockup's <strong>AI Background Replacer</strong> uses advanced engine to create context-aware backgrounds. Instead of just pasting your image, it harmonizes the lighting and edges to make it look real.
          </p>
        </div>

        <div className="tool-faq-grid">
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-palette"></i></div>
            <h3>Custom Colors?</h3>
            <p>Yes. Use our hex picker or preset studio colors for professional e-commerce shots.</p>
          </div>
          
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-image"></i></div>
            <h3>Custom Images?</h3>
            <p>Absolutely. Upload your own background texture or scene, and we'll blend your product into it.</p>
          </div>

          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-shield-lock"></i></div>
            <h3>Is it private?</h3>
            <p>100%. Images are processed securely and deleted after 24 hours.</p>
          </div>
        </div>
      </section>

    </div>
  );
}